import fetch from 'isomorphic-unfetch';
import Cookies from 'js-cookie';
import { createClient } from 'urql';

import { ApiEndpoints } from '../constants/ApiActions';
import { getCurrentClientVersion } from '../lib/ClientInfoUtils';
import { getAuthToken } from '../lib/ListenerUtils';
import { getStore } from '../store/StoreAccessor';

/**
 * @deprecated WEBCA-2418 - in order to stay consistent with how the majority of the app manages api state,
 * please use graphQLRequest from src/services/GraphQL.ts instead of this urql client.
 * urql / useQuery should only be used for maintaining past projects that already use it.
 */
const client = createClient({
  url: `/api/${ApiEndpoints.GRAPHQL}`,
  // using unfetch for IE11 polyfill
  fetch: window.fetch || fetch,
  // @ts-expect-error
  fetchOptions: () => {
    // @ts-expect-error
    const { getState } = getStore();
    return {
      headers: {
        'X-AuthToken': getAuthToken(getState()),
        'X-CsrfToken': Cookies.get('csrftoken'),
        'apollographql-client-name': 'web',
        'apollographql-client-version': getCurrentClientVersion(),
      },
    };
  },
});

export default client;
